import { Button, Col, Form, Input, Modal, Row, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../../constants/constants";
import { RatingConfigurationModel } from "../../../../../models/scenario-frontier.model";
import { ScenarioFrontierService } from "../../../../../services/scenario-frontier.service";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import i18n from "../../../../../utils/i18n";
import { AddIcon, DoubleArrowIcon } from "../../../../atoms/icon";
import PercentInput from "../../../../atoms/percent-input";

const RatingConfiguration = () => {

    const [data, setData] = useState<RatingConfigurationModel[]>([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [form] = Form.useForm();
    const [editItem, setEditItem] = useState<RatingConfigurationModel>();

    const columns: any[] = [
        {
            title: i18n.t("ScenarioFrontier.lbName"),
            dataIndex: 'name',
            key: 'name',
            width: '200px',
        },
        {
            title: i18n.t("ScenarioFrontier.lbPDmean"),
            dataIndex: 'pd_mean',
            key: 'pd_mean',
            align: "right",
            render: (mean: number) => AMOUNT_UTIL.converNumberToPercentage(mean)
        },
        {
            title: i18n.t("ScenarioFrontier.lbActions"),
            dataIndex: 'actions',
            key: 'actions',
            width: '250px',
            render: (text: string, record: RatingConfigurationModel) => <>
                <Space>
                    <span className="blue-text action-text" onClick={() => edit(record.id)}>
                        {i18n.t("ScenarioFrontier.lbEdit")}
                    </span>
                    <span className="red-text action-text" onClick={() => deleteItem(record.id)}>
                        {i18n.t("ScenarioFrontier.lbDelete")}
                    </span>
                </Space>
            </>
        }
    ]

    const getData = () => {
        setDataLoading(true);
        ScenarioFrontierService.getRatings().then(res => {
            setData(res.data);
        }).finally(() => setDataLoading(false));
    }

    const edit = (id: number) => {
        const item = data.find(p => p.id === id);
        setEditItem(item);
        form.setFieldsValue(item);
        setShowPopup(true);
    }

    const addNew = () => {
        form.resetFields();
        setEditItem(undefined);
        setShowPopup(true);
    }

    const save = () => {
        form.submit();
    }

    const formSubmit = async () => {
        const item = form.getFieldsValue();
        if (editItem && editItem.id) {
            await ScenarioFrontierService.updateRating(item);
        } else {
            await ScenarioFrontierService.addRating(item);
        }

        getData();
        setShowPopup(false);
    }

    const deleteItem = (id: number) => {
        Modal.confirm({
            content: i18n.t("ScenarioFrontier.contentDelete"),
            onCancel: () => { submitDelete(id) },
            icon: '',
            width: 304,
            okText: i18n.t("Global.lbCancel"),
            cancelText: i18n.t("ScenarioFrontier.btnDelete")
        });
    }

    const submitDelete = async (id: number) => {
        await ScenarioFrontierService.deleteRating(id);
        getData();
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <div className="variables-configuration">
            <h4>
                {i18n.t("ScenarioFrontier.lbRating")}
            </h4>

            <p className="sub-title">
                <DoubleArrowIcon />
                {i18n.t("ScenarioFrontier.lbRating")}
            </p>

            <Row>
                <Col span={24}>
                    <Table
                        className="second-table"
                        bordered
                        pagination={false}
                        loading={dataLoading}
                        dataSource={data}
                        columns={columns} rowKey="id" />
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Button className="add-more" type="default" shape="round" onClick={addNew}>
                        <AddIcon className="svg-icon" /> {i18n.t("ScenarioFrontier.btnAddmore")}
                    </Button>
                </Col>
            </Row>

            <Modal
                width={600}
                className="frontier-add-modal"
                title={editItem && editItem.id ? i18n.t("ScenarioFrontier.ttEditRating") : i18n.t("ScenarioFrontier.ttNewRating")}
                visible={showPopup}
                onCancel={() => { setShowPopup(false) }}
                footer={<Button htmlType="submit" type="primary" shape="round" onClick={save}>
                    {editItem && editItem.id ? i18n.t("ScenarioFrontier.btnSave") : i18n.t("ScenarioFrontier.btnSaveAdd")}
                </Button>}
            >
                <Form
                    layout="vertical"
                    className="modal-form"
                    onFinish={formSubmit}
                    form={form}
                    validateMessages={VALIDATION_MESSAGE_CONFIG}>
                    <Form.Item
                        name="id"
                        hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label={i18n.t("ScenarioFrontier.lbName")}
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="pd_mean"
                        label={i18n.t("ScenarioFrontier.lbPDmean")}
                        rules={[{ required: true }]}
                    >
                        <PercentInput />
                    </Form.Item>

                </Form>
            </Modal>

        </div>
    )
}

export default RatingConfiguration;